import HTTP from '@/utils/http';
import { EventBus } from '@/utils/event-bus';
import i18n from '@/locales';

const defaultState = () => ({
  integrations: {},
  externalIntegrations: {
    googledocs: {
      slug: 'google-docs',
      cta_link: 'https://workspace.google.com/marketplace/app/signable/810906142044',
    },
    zapier: {
      slug: 'zapier',
      cta_link: 'https://zapier.com/apps/signable/integrations',
    },
    make: {
      slug: 'make',
      cta_link: 'https://www.make.com/en/integrations/signable',
    },
  },
});

const IntegrationsModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET(state, integrations) {
      if (integrations.capsule.instance === null || integrations.capsule.instance.status !== 'configured') {
        // eslint-disable-next-line no-param-reassign
        delete integrations.capsule;
      }
      state.integrations = integrations;
    },
    UPDATE(state, updated) {
      state.integrations[updated.slug] = updated;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET_INTEGRATIONS({ commit }) {
      return HTTP({
        url: 'integrations',
      }).then(resp => resp.data.data).then((resp) => {
        commit('SET', resp);
      });
    },
    CREATE_INTEGRATION_INSTANCE({ commit }, { slug }) {
      return HTTP({
        method: 'post',
        url: `integrations/${slug}`,
      }).then(resp => resp.data.data).then((resp) => {
        commit('UPDATE', resp);
      });
    },
    DISCONNECT_INTEGRATION_INSTANCE({ commit }, { slug }) {
      return HTTP({
        method: 'delete',
        url: `integrations/${slug}`,
      }).then(resp => resp.data.data).then((resp) => {
        commit('SET', resp);
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('companySettings.integrations.disconnect.success'), icon: 'check', type: 'success' }));
      });
    },
    EXCHANGE_INSTANCE_TOKEN({ commit }, { slug, code }) {
      return HTTP({
        method: 'post',
        data: {
          auth_code: code,
        },
        url: `integrations/${slug}/authorize`,
      }).then(resp => resp.data.data).then((resp) => {
        commit('UPDATE', resp);
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('companySettings.integrations.authorize.success'), icon: 'check', type: 'success' }));
      });
    },
    UPDATE_INSTANCE_SETTINGS({ commit }, { slug, settings }) {
      return HTTP({
        method: 'put',
        data: {
          settings,
        },
        url: `integrations/${slug}`,
      }).then(resp => resp.data.data).then((resp) => {
        commit('UPDATE', resp);
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('companySettings.integrations.updateSuccess'), icon: 'check', type: 'success' }));
      });
    },
    DROPBOX_SET_FOLDER_FROM_SHARED_LINK({ commit }, { link }) {
      return HTTP({
        method: 'post',
        data: {
          link,
        },
        url: 'integrations/dropbox/set-folder-from-shared-link',
      }).then(resp => resp.data.data).then((resp) => {
        commit('UPDATE', resp);
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('companySettings.integrations.updateSuccess'), icon: 'check', type: 'success' }));
      });
    },
  },
  getters: {
    integrations: state => state.integrations,
    externalIntegrations: state => state.externalIntegrations,
  },
};

export default IntegrationsModule;
